import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import { createSelector } from "reselect";
import get from "lodash/get";
import map from "lodash/map";
import getAllHotspots from "./getAllHotspots";

export default function makeGetChapterHotspots() {
  const getChapterEntity = makeGetChapterEntity();

  return createSelector(
    getChapterEntity,
    getAllHotspots,
    (chapterEntity, allHotspots) => {
      if (!chapterEntity) return [];

      let returnValue = get(chapterEntity, "hotspots");
      returnValue = map(returnValue, ({ id, schema }) => ({
        ...allHotspots[id],
        schema,
      }));
      return returnValue;
    },
  );
}
